export enum ServiceTypeEnum {
    None = 0,
    Ride = 1,
    Delivery = 2,
    Food = 3,
    Grocery = 4,
    Hire = 5,
    Transfer = 6,
    ScanAndRide = 7,
    Single = 8,
    Charter = 9,
	Taxi = 10,
	DayTrip = 11,
	PublicTransport = 12,
	Experience = 13,
	Connex = 14
}
